import { fetchFavorites as fetchFavoritesRemote, starBlock, unstarBlock } from '@/lib/blocks/api';
import { reportNetworkError } from '@/lib/net/net-status';

import {
  getFavoriteIds,
  getFavoritePages,
  isFavoritePage,
  notifyFavoritesChanged,
  setFavoriteMembership,
  setFavoritePages,
  subscribeFavorites,
} from './favorites-store';
import type { FavoritePage } from './types';

export { getFavoritePages, isFavoritePage, notifyFavoritesChanged, subscribeFavorites };

let favoritesLoadGeneration = 0;

function applyFavoriteMembership(pageId: string, favorite: boolean): void {
  favoritesLoadGeneration += 1;
  setFavoriteMembership(pageId, favorite);
}

export async function loadFavorites(): Promise<FavoritePage[]> {
  const generation = ++favoritesLoadGeneration;
  try {
    const favorites = await fetchFavoritesRemote();
    if (generation !== favoritesLoadGeneration) {
      return getFavoritePages();
    }
    setFavoritePages(favorites);
    return favorites;
  } catch {
    return getFavoritePages();
  }
}

export async function toggleFavorite(blockId: string): Promise<boolean> {
  const next = !isFavoritePage(blockId);
  applyFavoriteMembership(blockId, next);
  try {
    if (next) {
      await starBlock(blockId);
    } else {
      await unstarBlock(blockId);
    }
    await loadFavorites();
    return isFavoritePage(blockId);
  } catch (err) {
    applyFavoriteMembership(blockId, !next);
    reportNetworkError({
      message: next ? 'Could not add this to favorites.' : 'Could not remove this from favorites.',
      detail: err instanceof Error ? err.message : String(err),
    });
    return !next;
  }
}

export function refreshFavoriteIds(): Set<string> {
  return new Set(getFavoriteIds());
}
